import {
  ShieldCheck,
  Cpu,
  Wrench,
  Layers,
  Headphones,
  Zap,
} from "lucide-react";
import { WHY_US } from "@/data/site";

const ICONS = { ShieldCheck, Cpu, Wrench, Layers, Headphones, Zap };

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-us-section"
      className="section-pad relative"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
            — Why Choose Us
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.1]">
            The standards we refuse{" "}
            <span className="italic text-[#FFC857]">to negotiate on.</span>
          </h2>
          <p className="mt-6 text-[#A0ABC0] text-base md:text-lg font-light max-w-2xl">
            Six promises we hold ourselves to on every project — residential,
            commercial or industrial.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_US.map((item, i) => {
            const Icon = ICONS[item.icon] || ShieldCheck;
            return (
              <div
                data-testid={`why-card-${i}`}
                key={item.title}
                className="glass rounded-sm p-8 transition-all duration-500 hover:-translate-y-1 group"
              >
                <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#FFC857]/25 to-[#F5A623]/10 flex items-center justify-center border border-[#FFC857]/20 group-hover:border-[#FFC857]/60 transition-colors">
                  <Icon className="h-6 w-6 text-[#FFC857]" />
                </div>
                <h3 className="mt-7 font-serif text-2xl text-white">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-[#A0ABC0] font-light leading-relaxed">
                  {item.body}
                </p>
                <div className="mt-6 inline-flex items-center text-xs uppercase tracking-[0.25em] text-[#FFC857]">
                  <span className="h-px w-8 bg-[#FFC857] mr-3" />
                  {String(i + 1).padStart(2, "0")} / 06
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
